import React from 'react';
import {Download} from '@mui/icons-material';
import {Button, Menu, MenuItem, useTheme} from '@mui/material';
import {ArrowDropDownIcon} from '@mui/x-date-pickers/icons';
import {useState} from 'react';
import CustomPopover, {usePopover} from 'src/minimal-components/custom-popover';
 import { getStatementPdfMRN } from '@shared/services/service-handlers/PrivateService';
 import EncryptUtils from 'src/utils/EncryptUtils';
 import { useSnackbar } from 'notistack';    
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getErrorMessage } from '@shared/utils/ErrorUtils';
import moment from 'moment';
type HighDetailStatementProps = {
  statementType: string;
  accountId: string | number | undefined;
  subSectionConfig: any; // replace `any` with proper interface if available
};
 
const HighDetailStatement
: React.FC<HighDetailStatementProps> = ({
  statementType,
  accountId,
  subSectionConfig
}) => {
     const [mrnStatementLoading, setMrnStatementLoading] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();
     const theme = useTheme();
    const popover = usePopover();
    const [anchorElmenuitem, setAnchorElmenuitem] = useState<null | HTMLElement>(
      null
    );
    const handleClicks = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorElmenuitem(event.currentTarget);
    };
 
    const handleMenuItemClick = async (option: string) => { 

  void statementType;
  let pdfContainer: HTMLDivElement | null = null;

  var tk = EncryptUtils.encryptedData({
    accountId,
    subSectionConfig
  });
    setMrnStatementLoading(true);

    var response = await getStatementPdfMRN({ tk });

    var paData = response?.data || [];
      //  console.log('High-level Data==>',paData)

if (!Array.isArray(paData) || paData.length === 0) {
      enqueueSnackbar(
        'No statement data returned from server',
        SnackBarConfig.getError()
      );
      setMrnStatementLoading(false);
      return;
    }

    if(option === 'High-level') {
  let measurementContainer: HTMLDivElement | null = null;

  try {


    const header = paData[0];
   const BalanceRows = paData.filter(
  (item: { Balance?: number }) => typeof item.Balance === "number"
);
    const TotalAccountBalanceRows = paData.filter((item: any) => item?.TotalPatientBalance);
    const totalAccountBalanceValue = Number(
      TotalAccountBalanceRows[0]?.TotalPatientBalance ?? 0
    );
    // console.log('TotalAccountBalanceRows==>',TotalAccountBalanceRows)
    // const shouldShowTotalBalanceSection = totalAccountBalanceValue > 0;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const topMargin = 15;
    const bottomMargin = 15;
    const usableHeight = pdfHeight - topMargin - bottomMargin;
    const pageWidthPx = 816;
    const usablePageHeightPx = Math.floor(
      (usableHeight * pageWidthPx) / pdfWidth
    );
    const tableStyle =
      'width:100%; border-collapse:collapse; font-size:12px; table-layout:fixed;';
    const highLevelHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th>Account Number</th>
          <th>Date Of Service</th>
          <th>Charges</th>
          <th>Payments</th>
          <th>Adjustments</th>
          <th>Balance</th>
        </tr>
      </thead>
    `;
    const totalBalanceHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th colspan="8" style="text-align:center; font-weight:700;">
            Total Balance
          </th>
        </tr>
        <tr style="background:#adadad;">
          <th>Legacy MRN</th>
          <th>30 Days</th>
          <th>60 Days</th>
          <th>90 Days</th>
          <th>120 Days</th>
          <th>365 Days</th>
          <th>Over 365 Days</th>
          <th>Total Account Balance</th>
        </tr>
      </thead>
    `;
    const formatAmount = (value: number) => (value ? `$${value.toFixed(2)}` : '');
    const headerSectionHtml = `
      <div style="background: #adadad; text-align:center; padding:10px; font-size:20px; font-weight:700; margin-bottom:16px;">
       Patient Summary Statement
      </div>

      <div style="display:flex; justify-content:space-between; gap:24px; margin-bottom:16px; font-size:12px;">
        <div>
          <div style="background: #adadad"><b>Billed By:</b></div>
          <div>${header?.BilledBy_Name || ''}</div>
          <div>${header?.BilledBy_AddressLine1 || ''}</div>
          <div>${header?.BilledBy_City || ''}, ${header?.BilledBy_State || ''} ${header?.BilledBy_Zipcode || ''}</div>
          <div>${header?.BilledBy_Phone || ''}</div>
        </div>

        <div>
          <div><b>Date:</b> ${header?.Date || ''}</div>
          <div><b>Customer Name:</b> ${header?.CustomerName || ''}</div>
          <div><b>Legacy MRN:</b> ${header?.LegacyMRN || ''}</div>
        </div>
      </div>
    `;
    const buildHighLevelRowHtml = (item: any) => {
      const accountnumber = item?.AccountNumber || '';
      const dateOfService = item?.DateOfService
        ? moment(item.DateOfService,'YYYY-MM-DD HH:mm:ss.SSS').format('MM/DD/YYYY')
        : '';
      const charges = Number(item?.Charges || 0);
      const payments = Number(item?.Payments || 0);
      const adjustment = Number(item?.Adjustment || 0);
      const balance = Number(item?.Balance || 0);

      return `
        <tr>
          <td align="center">${accountnumber}</td>
          <td align="center">${dateOfService}</td>
          <td align="center">${formatAmount(charges)}</td>
          <td align="center">${formatAmount(payments)}</td>
          <td align="center">${formatAmount(adjustment)}</td>
          <td align="center">${formatAmount(balance)}</td>
        </tr>
      `;
    };
    const buildTotalBalanceRowHtml = (item: any) => {
      // const accountnumber = item?.AccountNumber || '';
      const days_30 = Number(item?.['0-30'] ?? 0);
      const days_60 = Number(item?.['31-60'] ?? 0);
      const days_90 = Number(item?.['61-90'] ?? 0);
      const days_120 = Number(item?.['91-120'] ?? 0);
      const days_365 = Number(item?.['121-365'] ?? 0);
      const over_365_days = Number(item?.['365+'] ?? 0);
      // const totalAccountBalanceValue = Number(totalAccountBalanceValue ?? 0);

      return `
        <tr>
          <td align="right">${header?.LegacyMRN || ''}</td>
          <td align="right">${formatAmount(days_30)}</td>
          <td align="right">${formatAmount(days_60)}</td>
          <td align="right">${formatAmount(days_90)}</td>
          <td align="right">${formatAmount(days_120)}</td>
          <td align="right">${formatAmount(days_365)}</td>
          <td align="right">${formatAmount(over_365_days)}</td>
          <td align="right">${formatAmount(totalAccountBalanceValue ?? 0)}</td>
        </tr>
      `;
    };
    const buildHighLevelTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}" border="1" cellspacing="0" cellpadding="5">
        ${highLevelHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const buildTotalBalanceTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}; margin-top:24px;" border="1" cellspacing="0" cellpadding="5">
        ${totalBalanceHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const messageHtml = `
      <div style="display:flex; justify-content:space-between; gap:24px; margin-top:16px; font-size:12px;">
        <div>
          <div>Message :</div>
          <div>Please Make sure coordination of benefits are up to date</div>
        </div>

        <div style="border:2px solid #242424; height:100px; padding:10px; font-size:15px; font-weight:700;">
          <div>
              ${
                totalAccountBalanceValue > 0
                  ? `Please pay this <br/> Amount >>> ${formatAmount(totalAccountBalanceValue)}`
                  : totalAccountBalanceValue < 0
                  ? `${formatAmount(totalAccountBalanceValue)}`
                  : 'Paid in full'
              }
          </div>
        </div>
      </div>
    `;
    const buildPageHtml = (contentHtml: string) => `
      <div style="font-family: Arial, sans-serif; padding:32px; color:#333; background:#fff; width:${pageWidthPx}px; box-sizing:border-box;">
        ${contentHtml}
      </div>
    `;
    const addInvisibleTextLayer = (pageElement: HTMLElement) => {
      const pageRect = pageElement.getBoundingClientRect();
      const pxToMm = pdfWidth / pageWidthPx;
      const getTextSegments = (textNode: Text) => {
        const rawText = textNode.textContent || '';
        const segments: Array<{text: string; rect: DOMRect}> = [];
        const lineTolerance = 1;
        let pendingWhitespace = '';

        for (let index = 0; index < rawText.length; index += 1) {
          const character = rawText[index];
          const charRange = document.createRange();
          charRange.setStart(textNode, index);
          charRange.setEnd(textNode, index + 1);
          const rect = charRange.getBoundingClientRect();

          if (rect.width === 0 || rect.height === 0) {
            if (/\s/.test(character)) {
              pendingWhitespace += ' ';
            }
            continue;
          }

          const lastSegment = segments[segments.length - 1];
          const isSameLine =
            !!lastSegment &&
            Math.abs(lastSegment.rect.top - rect.top) <= lineTolerance &&
            Math.abs(lastSegment.rect.bottom - rect.bottom) <= lineTolerance;

          if (!lastSegment || !isSameLine) {
            segments.push({
              text: `${pendingWhitespace}${character}`,
              rect
            });
          } else {
            lastSegment.text += `${pendingWhitespace}${character}`;
            lastSegment.rect = new DOMRect(
              lastSegment.rect.left,
              Math.min(lastSegment.rect.top, rect.top),
              rect.right - lastSegment.rect.left,
              Math.max(lastSegment.rect.bottom, rect.bottom) -
                Math.min(lastSegment.rect.top, rect.top)
            );
          }

          pendingWhitespace = '';
        }

        return segments
          .map(segment => ({
            text: segment.text.replace(/\s+/g, ' ').trim(),
            rect: segment.rect
          }))
          .filter(segment => segment.text);
      };
      const walker = document.createTreeWalker(pageElement, NodeFilter.SHOW_TEXT, {
        acceptNode: node => {
          const text = node.textContent?.trim();
          return text ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });

      let currentNode = walker.nextNode();

      while (currentNode) {
        const textNode = currentNode as Text;
        const parentElement = textNode.parentElement;

        if (parentElement) {
          const textSegments = getTextSegments(textNode);

          if (textSegments.length > 0) {
            const style = window.getComputedStyle(parentElement);
            const fontSize = Math.max(
              6,
              parseFloat(style.fontSize || '12') * 0.75
            );

            pdf.setFontSize(fontSize);

            const renderInvisibleText = (text: string, x: number, y: number) => {
              const safeText = String(text || '');
              if (!safeText) return;

              const maxWidth = Math.max(10, pdf.internal.pageSize.getWidth() - x - 10);
              const rawLines = pdf.splitTextToSize(safeText, maxWidth);
              const lines: string[] = [];
              rawLines.forEach(line => {
                if (line.length <= 1000) {
                  lines.push(line);
                } else {
                  for (let off = 0; off < line.length; off += 1000) {
                    lines.push(line.slice(off, off + 1000));
                  }
                }
              });

              const lineHeight = Math.max(1, (fontSize || 10) * 0.3528);

              for (let idx = 0; idx < lines.length; idx += 1) {
                const ln = lines[idx];
                const yPos = y + lineHeight * idx;
                try {
                  pdf.text(ln, x, yPos, { renderingMode: 'invisible' as any });
                } catch (err) {
                  // If a single line still fails, try chopping smaller
                  for (let off = 0; off < ln.length; off += 500) {
                    const frag = ln.slice(off, off + 500);
                    try {
                      pdf.text(frag, x, yPos + (off / 500) * (lineHeight / 2), { renderingMode: 'invisible' as any });
                    } catch (err2) {
                      // give up on this fragment but continue
                      // eslint-disable-next-line no-console
                      console.error('Skipped invisible text fragment (len=', frag.length, ')');
                    }
                  }
                }
              }
            };

            textSegments.forEach(segment => {
              const x = (segment.rect.left - pageRect.left) * pxToMm;
              const y = topMargin + (segment.rect.bottom - pageRect.top) * pxToMm;

              renderInvisibleText(segment.text, x, y);
            });
          }
        }

        currentNode = walker.nextNode();
      }
    };

    measurementContainer = document.createElement('div');
    measurementContainer.style.position = 'fixed';
    measurementContainer.style.left = '-99999px';
    measurementContainer.style.top = '0';
    measurementContainer.style.width = `${pageWidthPx}px`;
    measurementContainer.style.opacity = '0';
    measurementContainer.style.pointerEvents = 'none';
    document.body.appendChild(measurementContainer);

    const getMeasuredHeight = (contentHtml: string) => {
      if (!measurementContainer) {
        return 0;
      }

      measurementContainer.innerHTML = buildPageHtml(contentHtml);
      return measurementContainer.offsetHeight;
    };

    const paginateRows = (
      rows: any[],
      buildRowHtml: (item: any) => string,
      buildTableHtml: (rowsHtml: string) => string,
      firstPageIntroHtml: string,
      continuationIntroHtml = ''
    ) => {
      if (rows.length === 0) {
        return [];
      }

      const pages: string[] = [];
      let currentRowsHtml = '';
      let isFirstPage = true;

      rows.forEach(item => {
        const nextRowsHtml = `${currentRowsHtml}${buildRowHtml(item)}`;
        const introHtml = isFirstPage ? firstPageIntroHtml : continuationIntroHtml;
        const nextPageHtml = `${introHtml}${buildTableHtml(nextRowsHtml)}`;

        if (
          currentRowsHtml &&
          getMeasuredHeight(nextPageHtml) > usablePageHeightPx
        ) {
          const currentIntroHtml = isFirstPage
            ? firstPageIntroHtml
            : continuationIntroHtml;
          pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
          currentRowsHtml = buildRowHtml(item);
          isFirstPage = false;
        } else {
          currentRowsHtml = nextRowsHtml;
        }
      });

      if (currentRowsHtml) {
        const currentIntroHtml = isFirstPage
          ? firstPageIntroHtml
          : continuationIntroHtml;
        pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
      }

      return pages;
    };

    const statementPages = paginateRows(
      BalanceRows,
      buildHighLevelRowHtml,
      buildHighLevelTableHtml,
      `${headerSectionHtml}<br/>`
    );
    const totalBalancePages = paginateRows(
          TotalAccountBalanceRows,
          buildTotalBalanceRowHtml,
          buildTotalBalanceTableHtml,
          '',
          ''
        );
    const pageContents: string[] =
      statementPages.length > 0 ? [...statementPages] : [headerSectionHtml];

    if (totalBalancePages.length > 0) {
      totalBalancePages.slice(0, -1).forEach(pageHtml => {
        pageContents.push(pageHtml);
      });

      const lastTotalBalancePageHtml =
        totalBalancePages[totalBalancePages.length - 1];
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${lastTotalBalancePageHtml}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(`${lastTotalBalancePageHtml}${messageHtml}`);
      }
    } else {
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(messageHtml);
      }
    }

    pdfContainer = document.createElement('div');
    pdfContainer.style.position = 'fixed';
    pdfContainer.style.left = '-99999px';
    pdfContainer.style.top = '0';
    pdfContainer.style.width = `${pageWidthPx}px`;
    pdfContainer.style.opacity = '0';
    pdfContainer.style.pointerEvents = 'none';
    document.body.appendChild(pdfContainer);

    for (let pageIndex = 0; pageIndex < pageContents.length; pageIndex += 1) {
      pdfContainer.innerHTML = buildPageHtml(pageContents[pageIndex]);
      const pageElement = pdfContainer.firstElementChild as HTMLElement | null;

      if (!pageElement) {
        continue;
      }

      const canvas = await html2canvas(pageElement, {
        scale: 1,
        useCORS: true,
        backgroundColor: '#ffffff'
      });
      const pageImgData = canvas.toDataURL('image/png');
      let imgWidth = pdfWidth;
      let pageImgHeight = (canvas.height * imgWidth) / canvas.width;
      const maxImgHeight = pdf.internal.pageSize.getHeight() - topMargin;

      if (pageImgHeight > maxImgHeight) {
        pageImgHeight = maxImgHeight;
        imgWidth = (canvas.width * pageImgHeight) / canvas.height;
      }

      if (pageIndex > 0) {
        pdf.addPage();
      }

      pdf.addImage(pageImgData, 'PNG', 0, topMargin, imgWidth, pageImgHeight);
      try {
        addInvisibleTextLayer(pageElement);
      } catch (err) {
        // don't block PDF generation for invisible text issues
        // eslint-disable-next-line no-console
        console.error('addInvisibleTextLayer failed:', err);
      }
    }
    const pageCount = pdf.getNumberOfPages();
        pdf.setFontSize(9);
        pdf.setTextColor(100);
 
        for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        
        pdf.text(
            `Page ${i} of ${pageCount}`,
            pdf.internal.pageSize.getWidth() - 15, // right side
            10,                                     // top margin
            { align: 'right' }
        );
        }
    pdf.save(`High_Level_Statement_${header?.LegacyMRN || ''}.pdf`);

    enqueueSnackbar(
      'High-level statement downloaded successfully',
      SnackBarConfig.getSuccess()
    );

  } catch (e) {
    console.error('Error fetching PA Statement:', e);
    enqueueSnackbar(getErrorMessage(e), SnackBarConfig.getError());
  } finally {
    if (pdfContainer?.parentNode) {
      pdfContainer.parentNode.removeChild(pdfContainer);
    }
    if (measurementContainer?.parentNode) {
      measurementContainer.parentNode.removeChild(measurementContainer);
    }
    setMrnStatementLoading(false);
  }
     
} else if(option === 'Detail-level') {
          void statementType;
  let detailPdfContainer: HTMLDivElement | null = null;
  let measurementContainer: HTMLDivElement | null = null;
  try {
    setMrnStatementLoading(true);


    if (!Array.isArray(paData) || paData.length === 0) {
          enqueueSnackbar(
      'No statement data returned from server',
      SnackBarConfig.getSuccess()
    );
    
    }

    const header = paData[0];
    const statementRows = paData.filter((item: any) => item?.Description);
      //  console.log('Detail-level Data==>',paData)
    const TotalAccountBalanceRows = paData.filter((item: any) => item?.TotalPatientBalance);
    const totalAccountBalanceValue = Number(
      TotalAccountBalanceRows[0]?.TotalPatientBalance ?? 0
    );
    // console.log('TotalAccountBalanceRows 545==>',totalAccountBalanceValue)
    // const shouldShowTotalBalanceSection = totalAccountBalanceValue > 0;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const topMargin = 15;
    const bottomMargin = 15;
    const usableHeight = pdfHeight - topMargin - bottomMargin;
    const pageWidthPx = 816;
    const usablePageHeightPx = Math.floor(
      (usableHeight * pageWidthPx) / pdfWidth
    );
    const tableStyle =
      'width:100%; border-collapse:collapse; font-size:12px; table-layout:fixed;';
    const detailColumnStyles =
      '<colgroup>' +
      '<col style="width:14%;">' +
      '<col style="width:43%;">' +
      '<col style="width:13%;">' +
      '<col style="width:10%;">' +
      '<col style="width:9%;">' +
      '<col style="width:11%;">' +
      '</colgroup>';
    const detailHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th>Account Number</th>
          <th>Description</th>
          <th>Date of Service</th>
          <th>Charges</th>
          <th>Payments</th>
          <th>Adjustments</th>
        </tr>
      </thead>
    `;
    const totalBalanceHeaderHtml = `
      <thead>
        <tr style="background:#adadad;">
          <th colspan="8" style="text-align:center; font-weight:700;">
            Total Balance
          </th>
        </tr>
        <tr style="background:#adadad;">
          <th>Legacy MRN</th>
          <th>30 Days</th>
          <th>60 Days</th>
          <th>90 Days</th>
          <th>120 Days</th>
          <th>365 Days</th>
          <th>Over 365 Days</th>
          <th>Total Account Balance</th>
        </tr>
      </thead>
    `;
    const formatAmount = (value: number) => (value ? `$${value.toFixed(2)}` : '');
    const headerSectionHtml = `
      <div style="background: #adadad; text-align:center; padding:10px; font-size:20px; font-weight:700; margin-bottom:16px;">
       Patient Detailed Statement
      </div>

      <div style="display:flex; justify-content:space-between; gap:24px; margin-bottom:16px; font-size:12px;">
        <div>
          <div style="background: #adadad"><b>Billed By:</b></div>
          <div>${header?.BilledBy_Name || ''}</div>
          <div>${header?.BilledBy_AddressLine1 || ''}</div>
          <div>${header?.BilledBy_City || ''}, ${header?.BilledBy_State || ''} ${header?.BilledBy_Zipcode || ''}</div>
          <div>${header?.BilledBy_Phone || ''}</div>
        </div>

        <div>
          <div><b>Date:</b> ${header?.Date || ''}</div>
          <div><b>Customer Name:</b> ${header?.CustomerName || ''}</div>
          <div><b>Legacy MRN:</b> ${header?.LegacyMRN || ''}</div>
        </div>
      </div>
    `;
    const buildDetailRowHtml = (item: any) => {
      const accountnumber = item?.AccountNumber || '';
      const charges = Number(item?.Charges || 0);
      const payments = Number(item?.Payments || 0);
      const adjustment = Number(item?.Adjustment || 0);
      const txDate = item?.ServiceDate
        ? moment(item.ServiceDate,'YYYY-MM-DD HH:mm:ss.SSS').format('MM/DD/YYYY')
        : '';

      return `
        <tr>
          <td>${accountnumber}</td>
          <td>${item?.DescriptionS || ''}</td>
          <td>${txDate}</td>
          <td align="right">${formatAmount(charges)}</td>
          <td align="right">${formatAmount(payments)}</td>
          <td align="right">${formatAmount(adjustment)}</td>
        </tr>
      `;
    };
    const buildTotalBalanceRowHtml = (item: any) => {
      // const accountnumber = item?.AccountNumber || '';
      const days_30 = Number(item?.['0-30'] ?? 0);
      const days_60 = Number(item?.['31-60'] ?? 0);
      const days_90 = Number(item?.['61-90'] ?? 0);
      const days_120 = Number(item?.['91-120'] ?? 0);
      const days_365 = Number(item?.['121-365'] ?? 0);
      const over_365_days = Number(item?.['365+'] ?? 0);
      // const totalAccountBalance = Number(item?.TotalAccountBalance ?? 0);

      return `
        <tr>
          <td>${header?.LegacyMRN || ''}</td>
          <td align="right">${formatAmount(days_30)}</td>
          <td align="right">${formatAmount(days_60)}</td>
          <td align="right">${formatAmount(days_90)}</td>
          <td align="right">${formatAmount(days_120)}</td>
          <td align="right">${formatAmount(days_365)}</td>
          <td align="right">${formatAmount(over_365_days)}</td>
          <td align="right">${formatAmount(totalAccountBalanceValue ?? 0)}</td>
        </tr>
      `;
    };
    const buildDetailTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}" border="1" cellspacing="0" cellpadding="5">
        ${detailColumnStyles}
        ${detailHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const buildTotalBalanceTableHtml = (rowsHtml: string) => `
      <table style="${tableStyle}; margin-top:24px;" border="1" cellspacing="0" cellpadding="5">
        ${totalBalanceHeaderHtml}
        <tbody>${rowsHtml}</tbody>
      </table>
    `;
    const messageHtml = `
      <div style="display:flex; justify-content:space-between; gap:24px; margin-top:16px; font-size:12px;">
        <div>
          <div>Message :</div>
          <div>Please Make sure coordination of benefits are up to date</div>
        </div>

        <div style="border:2px solid #242424; height:100px; padding:10px; font-size:15px; font-weight:700;">
          <div>
              ${
                totalAccountBalanceValue > 0
                  ? `Please pay this <br/> Amount >>> ${formatAmount(totalAccountBalanceValue)}`
                  : totalAccountBalanceValue < 0
                  ? `${formatAmount(totalAccountBalanceValue)}`
                  : 'Paid in full'
              }
          </div>
        </div>
      </div>
    `;
    const buildPageHtml = (contentHtml: string) => `
      <div style="font-family: Arial, sans-serif; padding:32px; color:#333; background:#fff; width:${pageWidthPx}px; box-sizing:border-box;">
        ${contentHtml}
      </div>
    `;
    const addInvisibleTextLayer = (pageElement: HTMLElement) => {
      const pageRect = pageElement.getBoundingClientRect();
      const pxToMm = pdfWidth / pageWidthPx;
      const getTextSegments = (textNode: Text) => {
        const rawText = textNode.textContent || '';
        const segments: Array<{text: string; rect: DOMRect}> = [];
        const lineTolerance = 1;
        let pendingWhitespace = '';

        for (let index = 0; index < rawText.length; index += 1) {
          const character = rawText[index];
          const charRange = document.createRange();
          charRange.setStart(textNode, index);
          charRange.setEnd(textNode, index + 1);
          const rect = charRange.getBoundingClientRect();

          if (rect.width === 0 || rect.height === 0) {
            if (/\s/.test(character)) {
              pendingWhitespace += ' ';
            }
            continue;
          }

          const lastSegment = segments[segments.length - 1];
          const isSameLine =
            !!lastSegment &&
            Math.abs(lastSegment.rect.top - rect.top) <= lineTolerance &&
            Math.abs(lastSegment.rect.bottom - rect.bottom) <= lineTolerance;

          if (!lastSegment || !isSameLine) {
            segments.push({
              text: `${pendingWhitespace}${character}`,
              rect
            });
          } else {
            lastSegment.text += `${pendingWhitespace}${character}`;
            lastSegment.rect = new DOMRect(
              lastSegment.rect.left,
              Math.min(lastSegment.rect.top, rect.top),
              rect.right - lastSegment.rect.left,
              Math.max(lastSegment.rect.bottom, rect.bottom) -
                Math.min(lastSegment.rect.top, rect.top)
            );
          }

          pendingWhitespace = '';
        }

        return segments
          .map(segment => ({
            text: segment.text.replace(/\s+/g, ' ').trim(),
            rect: segment.rect
          }))
          .filter(segment => segment.text);
      };
      const walker = document.createTreeWalker(pageElement, NodeFilter.SHOW_TEXT, {
        acceptNode: node => {
          const text = node.textContent?.trim();
          return text ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });

      let currentNode = walker.nextNode();

      while (currentNode) {
        const textNode = currentNode as Text;
        const parentElement = textNode.parentElement;

        if (parentElement) {
          const textSegments = getTextSegments(textNode);

          if (textSegments.length > 0) {
            const style = window.getComputedStyle(parentElement);
            const fontSize = Math.max(
              6,
              parseFloat(style.fontSize || '12') * 0.75
            );

            pdf.setFontSize(fontSize);

            const renderInvisibleText = (text: string, x: number, y: number) => {
              const safeText = String(text || '');
              if (!safeText) return;

              const maxWidth = Math.max(10, pdf.internal.pageSize.getWidth() - x - 10);
              const rawLines = pdf.splitTextToSize(safeText, maxWidth);
              const lines: string[] = [];
              rawLines.forEach(line => {
                if (line.length <= 1000) {
                  lines.push(line);
                } else {
                  for (let off = 0; off < line.length; off += 1000) {
                    lines.push(line.slice(off, off + 1000));
                  }
                }
              });

              const lineHeight = Math.max(1, (fontSize || 10) * 0.3528);

              for (let idx = 0; idx < lines.length; idx += 1) {
                const ln = lines[idx];
                const yPos = y + lineHeight * idx;
                try {
                  pdf.text(ln, x, yPos, { renderingMode: 'invisible' as any });
                } catch (err) {
                  // If a single line still fails, try chopping smaller
                  for (let off = 0; off < ln.length; off += 500) {
                    const frag = ln.slice(off, off + 500);
                    try {
                      pdf.text(frag, x, yPos + (off / 500) * (lineHeight / 2), { renderingMode: 'invisible' as any });
                    } catch (err2) {
                      // give up on this fragment but continue
                      // eslint-disable-next-line no-console
                      console.error('Skipped invisible text fragment (len=', frag.length, ')');
                    }
                  }
                }
              }
            };

            textSegments.forEach(segment => {
              const x = (segment.rect.left - pageRect.left) * pxToMm;
              const y = topMargin + (segment.rect.bottom - pageRect.top) * pxToMm;

              renderInvisibleText(segment.text, x, y);
            });
          }
        }

        currentNode = walker.nextNode();
      }
    };

    measurementContainer = document.createElement('div');
    measurementContainer.style.position = 'fixed';
    measurementContainer.style.left = '-99999px';
    measurementContainer.style.top = '0';
    measurementContainer.style.width = `${pageWidthPx}px`;
    measurementContainer.style.opacity = '0';
    measurementContainer.style.pointerEvents = 'none';
    document.body.appendChild(measurementContainer);

    const getMeasuredHeight = (contentHtml: string) => {
      if (!measurementContainer) {
        return 0;
      }

      measurementContainer.innerHTML = buildPageHtml(contentHtml);
      return measurementContainer.offsetHeight;
    };

    const paginateRows = (
      rows: any[],
      buildRowHtml: (item: any) => string,
      buildTableHtml: (rowsHtml: string) => string,
      firstPageIntroHtml: string,
      continuationIntroHtml = ''
    ) => {
      if (rows.length === 0) {
        return [];
      }

      const pages: string[] = [];
      let currentRowsHtml = '';
      let isFirstPage = true;

      rows.forEach(item => {
        const nextRowsHtml = `${currentRowsHtml}${buildRowHtml(item)}`;
        const introHtml = isFirstPage ? firstPageIntroHtml : continuationIntroHtml;
        const nextPageHtml = `${introHtml}${buildTableHtml(nextRowsHtml)}`;

        if (
          currentRowsHtml &&
          getMeasuredHeight(nextPageHtml) > usablePageHeightPx
        ) {
          const currentIntroHtml = isFirstPage
            ? firstPageIntroHtml
            : continuationIntroHtml;
          pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
          currentRowsHtml = buildRowHtml(item);
          isFirstPage = false;
        } else {
          currentRowsHtml = nextRowsHtml;
        }
      });

      if (currentRowsHtml) {
        const currentIntroHtml = isFirstPage
          ? firstPageIntroHtml
          : continuationIntroHtml;
        pages.push(`${currentIntroHtml}${buildTableHtml(currentRowsHtml)}`);
      }

      return pages;
    };

    const statementPages = paginateRows(
      statementRows,
      buildDetailRowHtml,
      buildDetailTableHtml,
      headerSectionHtml
    );
    const totalBalancePages = paginateRows(
          TotalAccountBalanceRows,
          buildTotalBalanceRowHtml,
          buildTotalBalanceTableHtml,
          '',
          ''
        );
    const pageContents: string[] =
      statementPages.length > 0 ? [...statementPages] : [headerSectionHtml];

    if (totalBalancePages.length > 0) {
      totalBalancePages.slice(0, -1).forEach(pageHtml => {
        pageContents.push(pageHtml);
      });

      const lastTotalBalancePageHtml =
        totalBalancePages[totalBalancePages.length - 1];
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${lastTotalBalancePageHtml}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(`${lastTotalBalancePageHtml}${messageHtml}`);
      }
    } else {
      const lastPageIndex = pageContents.length - 1;
      const combinedLastPageHtml = `${pageContents[lastPageIndex]}${messageHtml}`;

      if (getMeasuredHeight(combinedLastPageHtml) <= usablePageHeightPx) {
        pageContents[lastPageIndex] = combinedLastPageHtml;
      } else {
        pageContents.push(messageHtml);
      }
    }

    detailPdfContainer = document.createElement('div');
    detailPdfContainer.style.position = 'fixed';
    detailPdfContainer.style.left = '-99999px';
    detailPdfContainer.style.top = '0';
    detailPdfContainer.style.width = `${pageWidthPx}px`;
    detailPdfContainer.style.opacity = '0';
    detailPdfContainer.style.pointerEvents = 'none';
    document.body.appendChild(detailPdfContainer);

    const isVeryLargeExport = pageContents.length >= 250;
    const detailExportScale = isVeryLargeExport ? 0.92 : 1;
    const detailJpegQuality = isVeryLargeExport ? 0.8 : 0.9;
    const shouldAddInvisibleText = true;
    let totalPagesCompressed = 0;
    let totalImageBytes = 0;

    if (isVeryLargeExport) {
      // eslint-disable-next-line no-console
      console.warn('Detail-level export uses reduced scale and keeps invisible text layer for large page counts', {
        pageContents: pageContents.length,
        detailExportScale,
        detailJpegQuality
      });
    }

    for (let pageIndex = 0; pageIndex < pageContents.length; pageIndex += 1) {
      detailPdfContainer.innerHTML = buildPageHtml(pageContents[pageIndex]);
      const pageElement = detailPdfContainer.firstElementChild as HTMLElement | null;

      if (!pageElement) {
        continue;
      }

      const canvas = await html2canvas(pageElement, {
        scale: detailExportScale,
        useCORS: true,
        backgroundColor: '#ffffff'
      });

      let pageImgData = canvas.toDataURL('image/png');
      let imageType: 'PNG' | 'JPEG' = 'PNG';
      let originalImgLength = pageImgData.length;

      if (originalImgLength > 1200000 || pageContents.length > 250) {
        const jpegImgData = canvas.toDataURL('image/jpeg', detailJpegQuality);

        if (jpegImgData.length < originalImgLength) {
          pageImgData = jpegImgData;
          imageType = 'JPEG';
          totalPagesCompressed += 1;
          // eslint-disable-next-line no-console
          console.warn(
            'Using JPEG image for Detail-level PDF export to reduce page image size',
            {
              pageIndex,
              originalImgLength,
              jpegImgLength: pageImgData.length
            }
          );
        }
      }

      if (pageImgData.length > 1600000 && imageType === 'JPEG') {
        const lowerQualityJpeg = canvas.toDataURL('image/jpeg', 0.75);

        if (lowerQualityJpeg.length < pageImgData.length) {
          pageImgData = lowerQualityJpeg;
          // eslint-disable-next-line no-console
          console.warn(
            'Lowering JPEG quality for Detail-level PDF export to reduce size',
            {
              pageIndex,
              newLength: pageImgData.length
            }
          );
        }
      }

      totalImageBytes += pageImgData.length;

      let imgWidth = pdfWidth;
      let pageImgHeight = (canvas.height * imgWidth) / canvas.width;
      const maxImgHeight = pdf.internal.pageSize.getHeight() - topMargin;

      if (pageImgHeight > maxImgHeight) {
        pageImgHeight = maxImgHeight;
        imgWidth = (canvas.width * pageImgHeight) / canvas.height;
      }

      if (pageIndex > 0) {
        pdf.addPage();
      }

      pdf.addImage(
        pageImgData,
        imageType,
        0,
        topMargin,
        imgWidth,
        pageImgHeight
      );

      if (shouldAddInvisibleText) {
        try {
          addInvisibleTextLayer(pageElement);
        } catch (err) {
          // don't block PDF generation for invisible text issues
          // eslint-disable-next-line no-console
          console.error('addInvisibleTextLayer failed:', err);
        }
      }
    }

    const pageCount = pdf.getNumberOfPages();
        pdf.setFontSize(9);
        pdf.setTextColor(100);
 
        for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        
        pdf.text(
            `Page ${i} of ${pageCount}`,
            pdf.internal.pageSize.getWidth() - 15, // right side
            10,                                     // top margin
            { align: 'right' }
        );
        }

    try {
      pdf.save(`Detail_level_Statement_${header?.LegacyMRN || ''}.pdf`);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Detail-level pdf.save failed:', {
        pageCount,
        pageContents: pageContents.length,
        pdfPages: pdf.internal?.pages?.length,
        // mrn: header?.LegacyMRN,
        error: err
      });
      throw err;
      // enqueueSnackbar(getErrorMessage(err), SnackBarConfig.getError());
    }

    enqueueSnackbar(
      'Detail-level statement downloaded successfully',
      SnackBarConfig.getSuccess()
    );

  } catch (e) {
    console.error('Error fetching Detail-level Statement:', e);
    enqueueSnackbar(getErrorMessage(e), SnackBarConfig.getError());
  } finally {
    if (detailPdfContainer?.parentNode) {
      detailPdfContainer.parentNode.removeChild(detailPdfContainer);
    }
    if (measurementContainer?.parentNode) {
      measurementContainer.parentNode.removeChild(measurementContainer);
    }
    setMrnStatementLoading(false);
  }
      } 
      popover.onClose();
      setAnchorElmenuitem(null);
      handleClose();
    };
    const handleClose = () => {
      setAnchorElmenuitem(null);
    };
    return (
      <>
        <LoadingButton
          size="small"
          sx={{
            mr: 2, backgroundColor: theme.palette.primary.dark,
            color: 'white',
            '&:hover': {
              bgcolor: theme.palette.primary.main
            }
          }}
          type="button"
          variant="contained"
          loading={mrnStatementLoading}
          startIcon={<Download />}
          onClick={e => {
            // console.log('popover==>', popover);
            popover.onOpen(e);
          }}>
          Patient Statement
          <ArrowDropDownIcon />
       </LoadingButton>
        <CustomPopover
          open={popover.open}
          onClose={popover.onClose}
          sx={{width: 200, p: 0}}>
          {[
            'High-level',
            'Detail-level'
          ].map((option: any) => (
            <MenuItem key={option} onClick={() => handleMenuItemClick(option)}>
              {option}
            </MenuItem>
          ))}
        </CustomPopover>
      </>
    );
  // const [isLoading, setLoading] = useState<boolean>(false);
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
 
  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };
 
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };
 
  // const handleMenuItemClick = (option: string) => {
  //   // if()
 
  //   handleClose();
  // };
  // const theme = useTheme();
 
  // return (
  //   <>
  //     <Button
  //       disabled={isLoading}
  //       size="large"
  //       sx={{
  //         bgcolor: '#0a2a6d',
  //         color: 'white',
  //         borderTopLeftRadius: 'inherit !important',
  //         borderBottomLeftRadius: 'inherit !important',
  //         '&:hover': {
  //           bgcolor: theme.palette.primary.main
  //         }
  //       }}
  //       aria-controls={anchorEl ? 'split-button-menu' : undefined}
  //       // eslint-disable-next-line no-extra-boolean-cast
  //       aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
  //       aria-haspopup="menu"
  //       onClick={handleClick}>
  //       Patient Statement
  //       <ArrowDropDownIcon />
  //     </Button>
  //     <Menu
  //       id="split-button-menu"
  //       anchorEl={anchorEl}
  //       open={Boolean(anchorEl)}
  //       onClose={handleClose}>
  //       {[
  //         'High-level',
  //         'Detail-level'
  //       ].map((option: any) => (
  //         <MenuItem key={option} onClick={() => handleMenuItemClick(option)}>
  //           {option}
  //         </MenuItem>
  //       ))}
  //     </Menu>
  //   </>
  // );
};
 
export default HighDetailStatement;

